<h1 class="container-heading">Add status</h1>

<mat-card>
    <mat-card-content>
        <form *ngIf="formGroup" [formGroup]="formGroup" (submit)="handleFormSubmit()" autocomplete="off" novalidate>

            <div class="group flex">

                <mat-form-field class="full">
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="status">
                        <mat-option *ngFor='let status of statuses' [value]="status.toLowerCase()">
                            {{ status }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="full">
                    <mat-label>Message</mat-label>
                    <input matInput formControlName="messages">
                </mat-form-field>

                <div class="half">
                    <common-form-date-time
                            label="Pickup date"
                            [required]="true"
                            [value]="formGroup.value.pickup_date"
                            (valueChange)="formGroup.get('pickup_date').setValue($event)"
                    ></common-form-date-time>
                </div>

                <div class="half">
                    <common-form-select
                            label="Pickup date timezone"
                            [options]="timezones"
                            [search]="true"
                            [required]="true"
                            [value]="formGroup.value.pickup_date_tz"
                            (valueChange)="formGroup.get('pickup_date_tz').setValue($event)"
                    ></common-form-select>
                </div>


                <div class="full">
                    <common-form-date
                            label="Expected delivery"
                            [value]="formGroup.value.expected_delivery"
                            (valueChangeMoment)="formGroup.get('expected_delivery').setValue($event)"
                    ></common-form-date>
                </div>

                <mat-form-field class="full" *ngIf="formGroup.get('pod')">
                    <mat-label>Signed by (POD)</mat-label>
                    <input matInput formControlName="pod" required>
                </mat-form-field>

                <div class="full" *ngIf="formGroup.get('delivered_at')">
                    <common-form-date-time
                            label="Delivered at"
                            [value]="formGroup.value.delivered_at"
                            [required]="true"
                            (valueChangeMoment)="formGroup.get('delivered_at').setValue($event)"
                    ></common-form-date-time>
                </div>

                <div *ngIf="modal.params.file_upload" class="full margin-bottom-20">
                    <h3>
                       Upload status confirmation document:
                    </h3>
                    <div *ngIf="formGroup.value.attachment">
                        <b>Attachment:</b> {{ formGroup.value.attachment?.name }}
                    </div>
                    <common-file-upload
                            *ngIf="!formGroup.value.attachment"
                            (result)="onResult($event)"
                            [accept]="['pdf', 'jpeg', 'png']"
                            [required]="require_attachment"
                            [url]="['remark', 'order', modal.params.data.order.ref, 'remark_attachment']"
                    ></common-file-upload>
                </div>
            </div>

            <div class="actions">
                <button [disabled]="!this.formGroup || !this.formGroup.valid"
                        mat-raised-button color="primary" type="submit" class="main">
                    Save
                </button>
            </div>

        </form>
    </mat-card-content>
</mat-card>
